import ProvidersTable from '../components/ProvidersTable/ProvidersTable';

const tabConfigs = [
  {
    label: 'In-network providers',
    fieldName: 'in_network_providers',
    providersKey: 'inNetworkProviders',
    isActiveCheck: (isInNetworkTab) => isInNetworkTab
  },
  {
    label: 'Out of network providers',
    fieldName: 'out_of_network_providers',
    providersKey: 'outOfNetworkProviders',
    isActiveCheck: (isInNetworkTab) => !isInNetworkTab
  }
];

export const buildTabsData = ({
  isInNetworkTab,
  inNetworkProviders,
  outOfNetworkProviders,
  addProviderButton,
  oppositeStateMap,
  handleRemoveProvider,
  updateProviderStates
}) => {
  const providersByKey = { inNetworkProviders, outOfNetworkProviders };

  return tabConfigs.map(({ label, fieldName, providersKey, isActiveCheck }) => {
    const providers = providersByKey[providersKey];
    const isActive = isActiveCheck(isInNetworkTab);

    return {
      label,
      length: providers.length,
      lengthContainerClassName: `${isActive ? 'bg-primary-50' : ''} rounded-full border border-solid border-neutral-300`,
      lengthClassName: '!text-neutral-700 !font-500',
      content: (
        <ProvidersTable
          showStates
          providers={providers}
          onRemove={(id) => handleRemoveProvider(fieldName, id)}
          fieldName={fieldName}
          addProviderButton={addProviderButton}
          oppositeStateMap={oppositeStateMap[fieldName]}
          onStatesChange={(providerId, nextIds) =>
            updateProviderStates(fieldName, providerId, nextIds)
          }
        />
      )
    };
  });
};
